import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Actions\Answers\SkipAnswer::__invoke
* @see app/Actions/Answers/SkipAnswer.php:17
* @route '/scoring/{answer}/skip'
*/
const SkipAnswer = (args: { answer: number | { id: number } } | [answer: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SkipAnswer.url(args, options),
    method: 'post',
})

SkipAnswer.definition = {
    methods: ["post"],
    url: '/scoring/{answer}/skip',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Answers\SkipAnswer::__invoke
* @see app/Actions/Answers/SkipAnswer.php:17
* @route '/scoring/{answer}/skip'
*/
SkipAnswer.url = (args: { answer: number | { id: number } } | [answer: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { answer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { answer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            answer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        answer: typeof args.answer === 'object'
        ? args.answer.id
        : args.answer,
    }

    return SkipAnswer.definition.url
            .replace('{answer}', parsedArgs.answer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Answers\SkipAnswer::__invoke
* @see app/Actions/Answers/SkipAnswer.php:17
* @route '/scoring/{answer}/skip'
*/
SkipAnswer.post = (args: { answer: number | { id: number } } | [answer: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SkipAnswer.url(args, options),
    method: 'post',
})

export default SkipAnswer